import { api } from '../api';

export interface NeonCheckoutRequestBody {
  offerId: string;
  quantity: number;
  currency: string;
  country: string;
  locale: string;
  hash: string;
  offerType?: string;
  beneficiaries?: string[];
  chainId?: number;
  lastSeenPrice?: number;
  paymentType?: string;
}

export interface NeonCheckoutResponse {
  type: string;
  checkoutId: string;
  redirectUrl: string;
}

export interface NeonOrderResponse {
  orderId: string;
  offerId: string;
  paymentType: string;
  title?: { en?: string; ko?: string };
  price?: string;
  currency?: string;
  checkoutStatus?: string;
  checkoutDate?: string;
}

type NeonCheckoutPath = '/webshop/checkout' | '/guild/checkout';

export const NeonApi = {
  getNeon: async ({
    data,
    checkoutPath = '/webshop/checkout',
  }: {
    data: NeonCheckoutRequestBody;
    checkoutPath?: NeonCheckoutPath;
  }): Promise<NeonCheckoutResponse> => {
    const response = await api.post<NeonCheckoutResponse>(checkoutPath, data);
    return response.data;
  },

  getOrder: async (checkoutId: string): Promise<NeonOrderResponse> => {
    const response = await api.get<NeonOrderResponse>(`/webshop/order?order_id=${checkoutId}`);
    return response.data;
  },
};
